import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { getFileContent } from '../../../core/clients/omni-core/functions';

export const getFileUrl = (fileId: string, organizationId: string) =>
  environment.omniCoreApiUrl +
  getFileContent.PATH.replace('{oid}', organizationId).replace('{id}', fileId);

@Pipe({
  name: 'fileUrl',
})
export class OrganizationFileUrlPipe implements PipeTransform {
  transform(fileId: string, organizationId: string): string {
    return getFileUrl(fileId, organizationId);
  }
}
